module.exports = __webpack_public_path__ + "img/support_hand.f6567a55.png";